<template>
    <div>
        <banner heading="SIGNUP" description="SIGNUPDESCRIPTION" type="signup"></banner>

        <div class="container signup">
            <form action="/login" method="post" id="signup-form" v-on:submit.prevent>
                <div class="form-group">
                    <label for="signup-name">{{ $t('NAME') }}</label>
                    <b-form-input v-model="signup.name"
                                  id="signup-name"
                                  type="text"
                                  required
                                  :state="signup.name.length > 0"
                    ></b-form-input>
                </div>
                <div class="form-group">
                    <label for="signup-email">{{ $t('EMAIL') }}</label>
                    <b-form-input v-model="signup.email"
                                  id="signup-email"
                                  type="email"
                                  required
                                  :state="signup.email.length > 0"
                    ></b-form-input>
                </div>
                <div class="form-group">
                    <label for="signup-password">{{ $t('PASSWORD') }}</label>
                    <b-form-input v-model="signup.password"
                                  id="signup-password"
                                  type="password"
                                  required
                                  :state="signup.password.length > 0"
                    ></b-form-input>
                </div>
                <div class="form-group">
                    <button class="btn btn-primary" type="submit" @click="handleRegistration">{{ 'SIGNUP' | translate }}</button>
                </div>
            </form>
            <div class="alert alert-danger" v-if="error !== false">{{ error | translate }}</div>
        </div>
    </div>
</template>

<script>
import AuthService from '../services/auth.service';
import banner from './Banner.vue';

export default {
    name:    'signup',
    data() {
        let error = false;
        return {
            signup: {
                name:     '',
                email:    '',
                password: ''
            },
            error
        };
    },
    methods: {
        handleRegistration() {
            const auth = new AuthService();
            auth.signup(this.signup)
                .then(() => {
                    this.$router.push({ path: '/' });
                })
                .catch(err => {
                    if (err.response) {
                        console.log('err.resp', err.response);
                        if (err.response.data.errors.email && err.response.data.errors.email.message) {
                            this.error = err.response.data.errors.email.message;
                        } else if (err.response.data.errors.name && err.response.data.errors.name.message) {
                            this.error = err.response.data.errors.name.message;
                        } else if (err.response.data.errors.password && err.response.data.errors.password.message) {
                            this.error = err.response.data.errors.password.message;
                        } else {
                            this.error = err.response.data.message;
                        }
                        return err.response;
                    }
                });
        },
        failed(errors) {
            console.log('failed ', errors);
        },
        logout() {
            this.$cookie.delete('token');
        }
    },
    components: {
        banner
    }
};
</script>

<style scoped>
h1, h2 {
    font-weight: normal;
}

ul {
    list-style-type: none;
    padding:         0;
}

li {
    display: inline-block;
    margin:  0 10px;
}

a {
    color: #42b983;
}
</style>
